import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Typography, Divider } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import PrintStyles from "../../../components/PrintStyles";
import OrderHeader from "./OrderHeader";
import OrderItems from "./OrderItems";
import OrderPaymentSummary from "./OrderPaymentSummary"; // <- now only payment method
import OrderPaymentTotals from "./OrderPaymentTotals"; // <- new: subtotal, tax, total
import OrderContactInfo from "./OrderContactInfo";
import OrderFulfillmentInfo from "./OrderFulfillmentInfo";
import OrderActionButtons from "./OrderActionButtons";
import api from "../../../services/api";

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const { data } = await api.get(`/orders/${orderId}`);
        setOrder(data);
      } catch (error) {
        console.error("Failed to fetch order:", error);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrder();
    } else {
      setLoading(false);
    }
  }, [orderId]);

  if (loading) {
    return (
      <Box textAlign="center" mt={10}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Loading your order...
        </Typography>
      </Box>
    );
  }

  if (!order) {
    return (
      <Box textAlign="center" mt={10}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          No order data found
        </Typography>
        <OrderActionButtons onBack={() => navigate("/")} />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6, px: 3, mb: 6 }}>
      <PrintStyles />

      <OrderHeader order={order} />

      <Divider sx={{ my: 4 }} />

      <OrderItems
        items={order.items}
        receiptUrl={order.payment?.stripeReceiptUrl}
      />

      {/* Payment totals now BELOW items */}
      <OrderPaymentTotals payment={order.payment} />

      <Box className="keep-together" sx={{ mt: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <OrderFulfillmentInfo fulfillment={order.fulfillment} />
          </Grid>
          <Grid item xs={12} md={4}>
            <OrderContactInfo customer={order.customer} />
          </Grid>
          <Grid item xs={12} md={4}>
            <OrderPaymentSummary payment={order.payment} meta={order.meta} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default OrderConfirmation;
